import { UnifiedHeaderL2Variant, UnifiedHeaderMobileL3Layout, UnifiedHeaderNavItemKind, UnifiedHeaderNavItemVisibility } from '@oneappexchange/appx-design-system/modules/ax/unifiedHeaderV2/unifiedHeaderV2.constants';
import { Theme as BadgeTheme, Variant as BadgeVariant } from '@oneappexchange/appx-design-system/modules/ax/badge/badge.constants';
import { AGENTEXCHANGE_JP_SITE_URL, AGENTEXCHANGE_SITE_URL, APPX_JP_SITE_URL, APPX_SITE_URL } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { getSlackUtmSource } from '~/modules/helpers/slackMarketplaceLinkHelper';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { buildUrl } from '~/modules/utilities/route_utils';
import { StatusBadgeVariant } from '../../wds/statusBadge/statusBadge';
const COLLECTION_IMAGE_BASE_URL = '/images/unified-header-v2/collections';
const SALESFORCE_LABS_IMAGE_SRC = `${COLLECTION_IMAGE_BASE_URL}/salesforce-labs.png`;
const FORCE_COLLECTION_ITEM_ID = 'force-collection';
const GROUP_IMAGE_BASE_URL = '/images/unified-header-v2';
const productIcon = id => ({
  kind: 'image',
  src: `${GROUP_IMAGE_BASE_URL}/products/${id}.png`
});
const optionIds = count => Array.from({
  length: count
}, (_, index) => `option${String(index + 1)}`);
const appExchange = path => ({
  site: 'appExchange',
  path
});
const agentExchange = path => ({
  site: 'agentExchange',
  path
});
const external = (href, utmCampaign, utmContent) => ({
  site: 'external',
  href,
  utmCampaign,
  utmContent
});
const DESTINATION_ROUTES = {
  businessNeeds: {
    analytics: {
      action: appExchange('/explore/business-needs?category=analytics'),
      options: {
        option1: appExchange('/explore/business-needs?category=analyticsAndSiteMonitoring'),
        option2: appExchange('/explore/business-needs?category=dashboardsAndReports'),
        option3: appExchange('/explore/business-needs?category=dataCleansing'),
        option4: appExchange('/explore/business-needs?category=dataVisualization')
      }
    },
    commerce: {
      action: appExchange('/explore/business-needs?category=commerce'),
      options: {
        option1: appExchange('/explore/business-needs?category=eCommerce'),
        option2: appExchange('/explore/business-needs?category=liveCommerce'),
        option3: appExchange('/explore/business-needs?category=marketplace'),
        option4: appExchange('/explore/business-needs?category=paymentsProcessing'),
        option5: appExchange('/explore/business-needs?category=pointOfSaleAndInStore'),
        option6: appExchange('/explore/business-needs?category=productInformationManagement'),
        option7: appExchange('/explore/business-needs?category=ratingsAndReviews'),
        option8: appExchange('/explore/business-needs?category=shippingFulfillmentAndLogistics'),
        option9: appExchange('/explore/business-needs?category=subscriptions'),
        option10: appExchange('/explore/business-needs?category=warrantyAndReturnsManagement')
      }
    },
    collaboration: {
      action: appExchange('/explore/business-needs?category=collaboration'),
      options: {
        option1: appExchange('/explore/business-needs?category=chatAndWebConferencing'),
        option2: appExchange('/explore/business-needs?category=conversationalCommerce')
      }
    },
    'customer-service': {
      action: appExchange('/explore/business-needs?category=customerService'),
      options: {
        option1: appExchange('/explore/business-needs?category=agentProductivity'),
        option2: appExchange('/explore/business-needs?category=caseManagement'),
        option3: appExchange('/explore/business-needs?category=fieldService'),
        option4: appExchange('/explore/business-needs?category=routePlanning'),
        option5: appExchange('/explore/business-needs?category=telephony')
      }
    },
    erp: {
      action: appExchange('/explore/business-needs?category=enterpriseResourcePlanning'),
      options: {
        option1: appExchange('/explore/business-needs?category=humanResources'),
        option2: appExchange('/explore/business-needs?category=orderAndInventoryManagement'),
        option3: appExchange('/explore/business-needs?category=peopleManagement'),
        option4: appExchange('/explore/business-needs?category=punchoutSystem'),
        option5: appExchange('/explore/business-needs?category=warehouseManagementSystem')
      }
    },
    finance: {
      action: appExchange('/explore/business-needs?category=finance'),
      options: {
        option1: appExchange('/explore/business-needs?category=accounting'),
        option2: appExchange('/explore/business-needs?category=compensationManagement'),
        option3: appExchange('/explore/business-needs?category=grantManagement'),
        option4: appExchange('/explore/business-needs?category=timeAndExpense')
      }
    },
    'it-administration': {
      action: appExchange('/explore/business-needs?category=itAndAdministration'),
      options: {
        option1: appExchange('/explore/business-needs?category=adminAndDeveloperTools'),
        option2: appExchange('/explore/business-needs?category=auditAndCompliance'),
        option3: appExchange('/explore/business-needs?category=augmentedRealityAndVirtualReality'),
        option4: appExchange('/explore/business-needs?category=contentDeliveryNetwork'),
        option5: appExchange('/explore/business-needs?category=contentManagementSystem'),
        option6: appExchange('/explore/business-needs?category=dataBackupAndStorage'),
        option7: appExchange('/explore/business-needs?category=dataManagement'),
        option8: appExchange('/explore/business-needs?category=dataMigration'),
        option9: appExchange('/explore/business-needs?category=developerTools'),
        option10: appExchange('/explore/business-needs?category=informationManagement'),
        option11: appExchange('/explore/business-needs?category=integration'),
        option12: appExchange('/explore/business-needs?category=itManagement'),
        option13: appExchange('/explore/business-needs?category=searchAndRecommendation'),
        option14: appExchange('/explore/business-needs?category=security'),
        option15: appExchange('/explore/business-needs?category=translation')
      }
    },
    marketing: {
      action: appExchange('/explore/business-needs?category=marketing'),
      options: {
        option1: appExchange('/explore/business-needs?category=accountBasedMarketing'),
        option2: appExchange('/explore/business-needs?category=campaignManagement'),
        option3: appExchange('/explore/business-needs?category=eventManagement'),
        option4: appExchange('/explore/business-needs?category=feeds'),
        option5: appExchange('/explore/business-needs?category=loyalty'),
        option6: appExchange('/explore/business-needs?category=marketingAutomation'),
        option7: appExchange('/explore/business-needs?category=marketingAndIntelligence'),
        option8: appExchange('/explore/business-needs?category=massEmailsAndMessaging'),
        option9: appExchange('/explore/business-needs?category=personalization'),
        option10: appExchange('/explore/business-needs?category=socialChannels'),
        option11: appExchange('/explore/business-needs?category=surveys'),
        option12: appExchange('/explore/business-needs?category=testingAndSegmentation'),
        option13: appExchange('/explore/business-needs?category=websites')
      }
    },
    productivity: {
      action: appExchange('/explore/business-needs?category=productivity'),
      options: {
        option1: appExchange('/explore/business-needs?category=alerts'),
        option2: appExchange('/explore/business-needs?category=documentGeneration'),
        option3: appExchange('/explore/business-needs?category=documentManagement'),
        option4: appExchange('/explore/business-needs?category=emailAndCalendarSync'),
        option5: appExchange('/explore/business-needs?category=processManagement'),
        option6: appExchange('/explore/business-needs?category=projectManagement'),
        option7: appExchange('/explore/business-needs?category=timeAndDate')
      }
    },
    sales: {
      action: appExchange('/explore/business-needs?category=sales'),
      options: {
        option1: appExchange('/explore/business-needs?category=contractManagement'),
        option2: appExchange('/explore/business-needs?category=forecasting'),
        option3: appExchange('/explore/business-needs?category=geolocation'),
        option4: appExchange('/explore/business-needs?category=leadAndOpportunityManagement'),
        option5: appExchange('/explore/business-needs?category=partnerManagement'),
        option6: appExchange('/explore/business-needs?category=quotesAndOrders'),
        option7: appExchange('/explore/business-needs?category=salesIntelligence'),
        option8: appExchange('/explore/business-needs?category=salesMethodologies'),
        option9: appExchange('/explore/business-needs?category=salesProductivity')
      }
    }
  },
  products: {
    agentforce: {
      options: {
        option1: agentExchange('/explore/agentforce?agenticContent=agents'),
        option2: agentExchange('/explore/agentforce?agenticContent=actions'),
        option3: agentExchange('/explore/agentforce?agenticContent=subagents'),
        option4: agentExchange('/explore/agentforce?agenticContent=mcpServers')
      }
    },
    analytics: {
      options: {
        option1: appExchange('/explore/products?product=Tableau'),
        option2: appExchange('/explore/products?product=Tableau%20Cloud'),
        option3: appExchange('/explore/products?product=Tableau%20Server'),
        option4: appExchange('/explore/products?product=Tableau%20Next'),
        option5: appExchange('/explore/products?product=Tableau%20CRM')
      }
    },
    commerce: {
      options: {
        option1: appExchange('/explore/products?product=B2B%20Commerce%20Cloud'),
        option2: appExchange('/explore/products?product=B2C%20Commerce%20Cloud'),
        option3: appExchange('/explore/products?product=D2C%20Commerce'),
        option4: appExchange('/explore/products?product=Commerce%20Cloud%20Order%20Management')
      }
    },
    'data-360': {
      options: {
        option1: appExchange('/explore/products?product=CDP'),
        option2: appExchange('/explore/products?product=Customer%20Data%20Platform'),
        option3: appExchange('/explore/products?product=Data%20Cloud%20for%20Tableau')
      }
    },
    'industry-clouds': {
      options: {
        option1: appExchange('/explore/products?product=Consumer%20Goods%20Cloud'),
        option2: appExchange('/explore/products?product=Education%20Cloud'),
        option3: appExchange('/explore/products?product=Financial%20Services%20Cloud'),
        option4: appExchange('/explore/products?product=Health%20Cloud'),
        option5: appExchange('/explore/products?product=Government%20Cloud'),
        option6: appExchange('/explore/products?product=Manufacturing%20Cloud'),
        option7: appExchange('/explore/products?product=Net%20Zero%20Cloud'),
        option8: appExchange('/explore/products?product=Nonprofit%20Cloud')
      }
    },
    marketing: {
      options: {
        option1: appExchange('/explore/products?product=Marketing%20Cloud'),
        option2: appExchange('/explore/products?product=Pardot'),
        option3: appExchange('/explore/products?product=Marketing%20Cloud%20Advanced'),
        option4: appExchange('/explore/products?product=Marketing%20Cloud%20Growth'),
        option5: appExchange('/explore/products?product=Datorama')
      }
    },
    platform: {
      options: {
        option1: appExchange('/explore/products?product=Experience%20Cloud'),
        option2: appExchange('/explore/products?product=Hyperforce'),
        option3: appExchange('/explore/products?product=Platform%20Cloud'),
        option4: appExchange('/explore/products?product=Salesforce%20Web3'),
        option5: appExchange('/explore/products?product=Work.com'),
        option6: appExchange('/explore/products?product=Quip')
      }
    },
    sales: {
      options: {
        option1: appExchange('/explore/products?product=Sales%20Cloud'),
        option2: appExchange('/explore/products?product=Revenue%20Cloud'),
        option3: appExchange('/explore/products?product=Revenue%20Cloud%20Billing'),
        option4: appExchange('/explore/products?product=Revenue%20Cloud%20CPQ'),
        option5: appExchange('/explore/products?product=Revenue%20Cloud%20Subscription%20Management')
      }
    },
    service: {
      options: {
        option1: appExchange('/explore/products?product=Service%20Cloud'),
        option2: appExchange('/explore/products?product=Experience%20Cloud')
      }
    },
    slack: {
      options: {
        option1: appExchange('/appxSearchKeywordResults?type=apps&tech=slack'),
        option2: external('https://slack.com/marketplace/category/At07HZAKCSAC-ai-apps-assistants?sort=popularity', 'products', 'slack_agents')
      }
    }
  },
  solutions: {
    apps: {
      options: {
        option1: appExchange('/appxSearchKeywordResults?tech=force%2Fpackage'),
        option2: appExchange('/appxSearchKeywordResults?type=apps&tech=slack'),
        option3: appExchange('/appxSearchKeywordResults?tech=force%2Fbolt'),
        option4: appExchange('/appxSearchKeywordResults?tech=tableau%2Faccelerator')
      }
    },
    agents: {
      options: {
        option1: agentExchange('/explore/agentforce?agenticContent=agents'),
        option2: agentExchange('/explore/agentforce?agenticContent=subagents'),
        option3: external('https://slack.com/marketplace/category/At07HZAKCSAC-ai-apps-assistants?sort=popularity', 'solution_types', 'slack_agents'),
        option4: agentExchange('/appxSearchKeywordResults?type=externalAgents&tech=ai-skill'),
        option5: agentExchange('/appxSearchKeywordResults?type=externalAgents&tech=ai-plugin'),
        option6: agentExchange('/explore/agentforce?agenticContent=actions'),
        option7: agentExchange('/explore/agentforce?agenticContent=mcpServers')
      }
    },
    connectors: {
      options: {
        option1: agentExchange('/explore/agentforce?agenticContent=mcpServers'),
        option2: appExchange('/appxSearchKeywordResults?tech=salesforce-platform%2Fapi'),
        option3: appExchange('/appxSearchKeywordResults?tech=marketing-cloud%2Fapi'),
        option4: appExchange('/appxSearchKeywordResults?tech=b2c-commerce%2Fpackage'),
        option5: appExchange('/appxSearchKeywordResults?tech=b2c-commerce%2Fapi')
      }
    },
    'building-blocks': {
      options: {
        option1: appExchange('/appxSearchKeywordResults?tech=force%2Flightning'),
        option2: appExchange('/appxSearchKeywordResults?tech=force%2Fflow')
      }
    }
  },
  consultants: {
    product: {
      action: appExchange('/consulting'),
      options: {
        option1: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Agentforce'),
        option2: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Analytics'),
        option3: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Agentforce%20Commerce'),
        option4: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Data%20360%3BData%20360'),
        option5: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Agentforce%20Marketing'),
        option6: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Platform'),
        option7: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Agentforce%20Sales'),
        option8: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Agentforce%20Service'),
        option9: appExchange('/appxSearchKeywordResults?type=consultants&sfExpertise=Slack%3BSlack')
      }
    },
    industry: {
      action: appExchange('/consulting'),
      options: {
        option1: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=agriculture'),
        option2: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=automotive'),
        option3: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=communications'),
        option4: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=consumer'),
        option5: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=education'),
        option6: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=energy'),
        option7: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=engineering'),
        option8: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=financial'),
        option9: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=health'),
        option10: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=tech'),
        option11: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=manufacturing'),
        option12: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=media'),
        option13: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=netzero'),
        option14: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=nonprofit'),
        option15: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=professional'),
        option16: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=public'),
        option17: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=retail'),
        option18: appExchange('/appxSearchKeywordResults?type=consultants&industryExpertise=travel')
      }
    }
  },
  learn: {
    role: {
      action: appExchange('/learn'),
      options: {
        option1: appExchange('/learn?persona=administrator'),
        option2: appExchange('/learn?persona=architect'),
        option3: appExchange('/learn?persona=business-operations-manager'),
        option4: appExchange('/learn?persona=consultant'),
        option5: appExchange('/learn?persona=data-analyst'),
        option6: appExchange('/learn?persona=designer'),
        option7: appExchange('/learn?persona=developer'),
        option8: appExchange('/learn?persona=educator'),
        option9: appExchange('/learn?persona=executive'),
        option10: appExchange('/learn?persona=marketer')
      }
    },
    type: {
      action: appExchange('/learn'),
      options: {
        option1: appExchange('/learn?contentType=app-guide'),
        option2: appExchange('/learn?contentType=app-listicle'),
        option3: appExchange('/learn?contentType=educational'),
        option4: appExchange('/learn?contentType=events'),
        option5: appExchange('/learn?contentType=how-to'),
        option6: appExchange('/learn?contentType=partner-guidance'),
        option7: appExchange('/learn?contentType=success-story'),
        option8: appExchange('/learn?contentType=thought-leadership')
      }
    }
  }
};
const resolveDestinationHref = (route, isAgentExchange) => {
  if (route.site === 'external') {
    const language = getUserLanguage();
    const isJapanese = language === JAPANESE_LANGUAGE_CODE;
    const domain = isAgentExchange ? 'agentexchange' : isJapanese ? 'appexchange-jp' : 'appexchange';
    return buildUrl(route.href, {
      utm_source: getSlackUtmSource(domain, language),
      utm_medium: 'navigation',
      utm_campaign: route.utmCampaign,
      utm_content: route.utmContent
    });
  }
  const isJapanese = getUserLanguage() === JAPANESE_LANGUAGE_CODE;
  const baseUrl = route.site === 'agentExchange' ? (isJapanese ? AGENTEXCHANGE_JP_SITE_URL : AGENTEXCHANGE_SITE_URL) || AGENTEXCHANGE_SITE_URL : (isJapanese ? APPX_JP_SITE_URL : APPX_SITE_URL) || APPX_SITE_URL;
  return `${baseUrl}${route.path}`;
};
const NAVIGATION_STRUCTURE = [{
  id: 'business-needs',
  labelKey: 'businessNeeds',
  variant: UnifiedHeaderL2Variant.TABBED,
  showCollections: true,
  groups: [{
    id: 'sales',
    optionIds: optionIds(9),
    icon: {
      kind: 'ax-icon',
      name: 'send'
    }
  }, {
    id: 'marketing',
    optionIds: optionIds(13),
    icon: {
      kind: 'ax-icon',
      name: 'campaign'
    }
  }, {
    id: 'it-administration',
    optionIds: optionIds(15),
    icon: {
      kind: 'ax-icon',
      name: 'screen'
    }
  }, {
    id: 'customer-service',
    optionIds: optionIds(5),
    icon: {
      kind: 'ax-icon',
      name: 'heart'
    }
  }, {
    id: 'finance',
    optionIds: optionIds(4),
    icon: {
      kind: 'ax-icon',
      name: 'card_details'
    }
  }, {
    id: 'analytics',
    optionIds: optionIds(4),
    icon: {
      kind: 'ax-icon',
      name: 'metrics'
    }
  }, {
    id: 'productivity',
    optionIds: optionIds(7),
    icon: {
      kind: 'ax-icon',
      name: 'task'
    }
  }, {
    id: 'commerce',
    optionIds: optionIds(10),
    icon: {
      kind: 'ax-icon',
      name: 'cart'
    }
  }, {
    id: 'collaboration',
    optionIds: optionIds(2),
    icon: {
      kind: 'ax-icon',
      name: 'groups'
    }
  }, {
    id: 'erp',
    optionIds: optionIds(5),
    icon: {
      kind: 'ax-icon',
      name: 'archive'
    }
  }]
}, {
  id: 'products',
  labelKey: 'products',
  variant: UnifiedHeaderL2Variant.TABBED,
  showCollections: true,
  groups: [{
    id: 'agentforce',
    optionIds: ['option2', 'option3', 'option1', 'option4'],
    icon: productIcon('agentforce')
  }, {
    id: 'sales',
    optionIds: optionIds(5),
    icon: productIcon('sales')
  }, {
    id: 'service',
    optionIds: optionIds(2),
    icon: productIcon('service')
  }, {
    id: 'marketing',
    optionIds: optionIds(5),
    icon: productIcon('marketing')
  }, {
    id: 'commerce',
    optionIds: optionIds(4),
    icon: productIcon('commerce')
  }, {
    id: 'analytics',
    optionIds: optionIds(5),
    statusBadges: {
      option4: StatusBadgeVariant.New
    },
    icon: productIcon('analytics')
  }, {
    id: 'slack',
    optionIds: optionIds(3),
    icon: productIcon('slack')
  }, {
    id: 'data-360',
    optionIds: optionIds(3),
    icon: productIcon('data-360')
  }, {
    id: 'platform',
    optionIds: optionIds(6),
    icon: productIcon('platform')
  }, {
    id: 'industry-clouds',
    optionIds: optionIds(8),
    icon: productIcon('industry-clouds'),
    columns: 2
  }]
}, {
  id: 'solutions',
  labelKey: 'solutions',
  variant: UnifiedHeaderL2Variant.TABBED,
  showCollections: true,
  promotion: {
    id: 'salesforce-labs',
    labelKey: 'salesforceLabs',
    icon: {
      kind: 'image',
      src: SALESFORCE_LABS_IMAGE_SRC
    },
    route: appExchange('/collection/SalesforceLabs')
  },
  groups: [{
    id: 'agents',
    optionIds: optionIds(7),
    statusBadges: {
      option4: StatusBadgeVariant.Beta,
      option5: StatusBadgeVariant.Beta
    },
    icon: {
      kind: 'ax-icon',
      name: 'sparkles'
    },
    mobileSections: [{
      id: 'agents',
      labelKey: 'agents',
      optionIds: optionIds(3)
    }, {
      id: 'agent-tools',
      labelKey: 'agentTools',
      optionIds: ['option4', 'option5', 'option6', 'option7']
    }]
  }, {
    id: 'apps',
    optionIds: optionIds(4),
    icon: {
      kind: 'ax-icon',
      name: 'apps'
    }
  }, {
    id: 'connectors',
    optionIds: optionIds(6),
    icon: {
      kind: 'ax-icon',
      name: 'environment_hub'
    }
  }, {
    id: 'building-blocks',
    optionIds: optionIds(3),
    icon: {
      kind: 'ax-icon',
      name: 'builder'
    }
  }]
}, {
  id: 'consultants',
  labelKey: 'consultants',
  variant: UnifiedHeaderL2Variant.TABBED,
  groups: [{
    id: 'product',
    optionIds: ['option1', 'option3', 'option5', 'option7', 'option8', 'option2', 'option4', 'option6', 'option9'],
    icon: {
      kind: 'ax-icon',
      name: 'data_cloud'
    },
    columns: 3
  }, {
    id: 'industry',
    optionIds: optionIds(18),
    icon: {
      kind: 'ax-icon',
      name: 'company'
    },
    columns: 3
  }]
}, {
  id: 'learn',
  labelKey: 'learn',
  variant: UnifiedHeaderL2Variant.TABBED,
  groups: [{
    id: 'role',
    optionIds: optionIds(10),
    icon: {
      kind: 'ax-icon',
      name: 'user_role'
    },
    columns: 3
  }, {
    id: 'type',
    optionIds: optionIds(8),
    icon: {
      kind: 'ax-icon',
      name: 'description'
    },
    columns: 3
  }]
}];
const COLLECTION_STRUCTURE = [{
  menuId: 'business-needs',
  items: [{
    id: 'sales-app-guide',
    route: agentExchange('/collections/sales-app-guide')
  }, {
    id: 'service-app-guide',
    route: agentExchange('/collections/service-app-guide')
  }, {
    id: 'private-offers',
    route: agentExchange('/collections/agentexchange-private-offers')
  }]
}, {
  menuId: 'products',
  items: [{
    id: 'data-cloud',
    route: agentExchange('/collections/data-360')
  }, {
    id: 'slack-agentforce',
    route: agentExchange('/collections/slack-and-agentforce')
  }, {
    id: 'salesforce-foundations',
    route: agentExchange('/collections/salesforce-foundations')
  }]
}, {
  menuId: 'solutions',
  items: [{
    id: 'agentic-enterprise',
    route: agentExchange('/collections/agentexchange-solutions')
  }, {
    id: 'mcp-partners',
    route: agentExchange('/collections/agentforce-mcp')
  }, {
    id: FORCE_COLLECTION_ITEM_ID,
    route: appExchange('/collection/SalesforceLabs')
  }]
}];
const COLLECTIONS_ROUTE = agentExchange('/collections');
const requiredValue = (values, id, context) => {
  const value = values[id];
  if (!value) {
    throw new Error(`Missing Unified Header V2 localization for ${context}.${id}`);
  }
  return value;
};
const optionalValue = (value, key) => {
  if (!(key in value)) {
    return undefined;
  }
  const candidate = Reflect.get(value, key);
  return typeof candidate === 'string' ? candidate : undefined;
};
const createLinks = (structure, definition, routes, statusBadgeLabels, isAgentExchange) => structure.optionIds.flatMap(optionId => {
  const route = routes.options[optionId];
  if (!route) {
    return [];
  }
  const option = requiredValue(definition.options, optionId, `${structure.id}.options`);
  const badgeVariant = structure.statusBadges?.[optionId];
  return {
    id: `${structure.id}-${optionId}`,
    label: option.label,
    description: optionalValue(option, 'description'),
    href: resolveDestinationHref(route, isAgentExchange),
    badge: badgeVariant ? {
      text: statusBadgeLabels[badgeVariant],
      variant: BadgeVariant.Default,
      theme: BadgeTheme.Gold
    } : undefined
  };
});
const createGroup = (structure, definition, labels, routes, isAgentExchange, statusBadgeLabels) => {
  const action = optionalValue(definition, 'action');
  return {
    id: structure.id,
    label: definition.label,
    heading: definition.heading,
    description: optionalValue(definition, 'description'),
    icon: structure.icon,
    columns: structure.columns,
    links: createLinks(structure, definition, routes, statusBadgeLabels, isAgentExchange),
    action: action && routes.action ? {
      id: `browse-${structure.id}`,
      label: action,
      href: resolveDestinationHref(routes.action, isAgentExchange)
    } : undefined,
    mobileL3Layout: structure.mobileSections ? UnifiedHeaderMobileL3Layout.GROUPED : undefined,
    mobileL3Sections: structure.mobileSections?.map(section => ({
      id: section.id,
      label: labels.mobileSections[section.labelKey].label,
      description: labels.mobileSections[section.labelKey].description,
      destinationIds: section.optionIds.map(optionId => `${structure.id}-${optionId}`)
    }))
  };
};
const createGroups = (menu, labels, isAgentExchange, statusBadgeLabels) => {
  const definitions = labels.groups[menu.labelKey];
  const menuRoutes = DESTINATION_ROUTES[menu.labelKey];
  return menu.groups.map(group => createGroup(group, requiredValue(definitions, group.id, `${menu.labelKey}.groups`), labels, requiredValue(menuRoutes, group.id, `${menu.labelKey}.routes`), isAgentExchange, statusBadgeLabels));
};
const createL2Content = (menu, labels, isAgentExchange, statusBadgeLabels) => {
  return {
    itemId: menu.id,
    variant: menu.variant,
    selectorAriaLabel: labels.selectorAriaLabels[menu.labelKey],
    groups: createGroups(menu, labels, isAgentExchange, statusBadgeLabels),
    promotion: menu.promotion ? {
      id: menu.promotion.id,
      ...labels.promotions[menu.promotion.labelKey],
      icon: menu.promotion.icon,
      href: resolveDestinationHref(menu.promotion.route, isAgentExchange)
    } : undefined,
    showCollections: menu.showCollections
  };
};
const createCollections = (labels, isAgentExchange) => Object.fromEntries(COLLECTION_STRUCTURE.map(({
  menuId,
  items: collectionItems
}) => {
  const items = labels.collections.menus[menuId].items;
  return [menuId, {
    heading: labels.collections.heading,
    items: collectionItems.map(({
      id,
      route
    }) => ({
      id,
      ...requiredValue(items, id, `${menuId}.collections`),
      image: id === FORCE_COLLECTION_ITEM_ID ? {
        src: SALESFORCE_LABS_IMAGE_SRC
      } : {
        src: `${COLLECTION_IMAGE_BASE_URL}/${id}.png`
      },
      href: resolveDestinationHref(route, isAgentExchange)
    })),
    action: {
      id: `view-${menuId}-collections`,
      ...labels.collections.action,
      href: resolveDestinationHref(COLLECTIONS_ROUTE, isAgentExchange)
    }
  }];
}));
export const createHeaderV2Navigation = (_homeUrl, labels, isAgentExchange, statusBadgeLabels) => {
  const collections = createCollections(labels, isAgentExchange);
  const mobileCollectionCards = COLLECTION_STRUCTURE.flatMap(({
    menuId
  }) => collections[menuId].items.map(({
    id,
    label,
    description,
    href,
    target
  }) => ({
    id,
    label,
    description,
    href,
    target
  })));
  return {
    navItems: [...NAVIGATION_STRUCTURE.map(({
      id,
      labelKey
    }) => ({
      id,
      kind: UnifiedHeaderNavItemKind.DISCLOSURE,
      label: labels.navItems[labelKey]
    })), {
      id: 'collections',
      kind: UnifiedHeaderNavItemKind.DISCLOSURE,
      label: labels.navItems.collections,
      visibility: UnifiedHeaderNavItemVisibility.MOBILE
    }],
    l2Content: [...NAVIGATION_STRUCTURE.map(menu => createL2Content(menu, labels, isAgentExchange, statusBadgeLabels)), {
      itemId: 'collections',
      variant: UnifiedHeaderL2Variant.CARD_GRID,
      heading: labels.navItems.collections,
      cards: mobileCollectionCards,
      action: {
        id: 'view-all-collections',
        ...labels.collections.action,
        href: resolveDestinationHref(COLLECTIONS_ROUTE, isAgentExchange)
      }
    }],
    collections
  };
};